import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";
import { Button } from "../../../../components/ui/button";
import { setNextButtonClick } from "../../../../redux/slice/temporaryStorage/temporaryStorageSlice";
import OrderDataStep from "../../equipmentRental/OrderDataStep";
import { useTemporaryStorageStepCounter } from "../hooks/useTemporaryStorageStepCounter";

export default function TemporaryStorageDateDurationSelectionStep() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { current, total } = useTemporaryStorageStepCounter("dateDurationSelection");
  
  const { orderData } = useSelector(
    (state: RootState) => state.bookingCreation
  );

  const handleClickNext = () => {
    dispatch(setNextButtonClick());
  };
  return (
    <div className="flex flex-col items-center justify-center px-5">
      {/* Step Counter */}
      <p className="-mt-5 mb-6 text-xs text-muted-foreground text-center" role="status" aria-live="polite">
        {t("temporary_storage.new_booking.step_counter", {
          current,
          total,
          defaultValue: "Schritt {{current}} von {{total}}",
        })}
      </p>

      <OrderDataStep />
      <div className="fixed flex w-full max-w-md px-5 bottom-4 m-auto items-center justify-center">
        <Button
          size="lg"
          variant="primary"
          className="w-full"
          disabled={!orderData.duration}
          onClick={handleClickNext}
        >
          {t("temporary_storage.new_booking.location.next_button_title")}
        </Button>
      </div>
    </div>
  );
}
